/**
 * The corner-radius scale's one named value outside the theme units (docs/design-system.md
 * section 3). In `sx`, `borderRadius: 1 | 2 | 3` is 4/8/12px and `"50%"` is a circle; a pill (a
 * control whose ends are fully round, however tall it is) takes `PILL_RADIUS`. CSS clamps a radius
 * to half the box's shorter side, so any length past that draws the same full round end.
 */
export const PILL_RADIUS = "999px";
